import { BaseAuthedApiRequest } from '../api';
import { AppGroup } from '../types';

export const APP_GROUPS_UPDATED = 'APP_GROUPS_UPDATED';
export const APP_GROUP_STATE_UPDATED = 'APP_GROUP_STATE_UPDATED';
export const TRY_DELETE_APP_GROUP = 'TRY_DELETE_APP_GROUP';
export const APP_GROUPS_DELETED = 'APP_GROUPS_DELETED';

export interface ConnectedAppGroupEntityResponse {
    orgId: string;
    orgIdParam: string;
    appGroup: AppGroup;
}

export interface DeleteAppGroupRequest extends BaseAuthedApiRequest {
    orgIdParam: string;
    appGroupId: string;
}

export interface DeletedAppGroupPayload {
    orgId: string;
    orgIdParam: string;
    appGroupId: string;
}

// Actions

export interface AppGroupsUpdatedAction {
    type: typeof APP_GROUPS_UPDATED;
    payload: ConnectedAppGroupEntityResponse[];
}

export interface AppGroupStateUpdatedAction {
    type: typeof APP_GROUP_STATE_UPDATED;
    payload: ConnectedAppGroupEntityResponse;
}

export interface TryDeleteAppGroupAction {
    type: typeof TRY_DELETE_APP_GROUP;
    payload: DeleteAppGroupRequest;
}

export interface AppGroupsDeletedAction {
    type: typeof APP_GROUPS_DELETED;
    payload: DeletedAppGroupPayload[];
}

// Action Creators

export const appGroupsUpdated: (payload: ConnectedAppGroupEntityResponse[]) => AppGroupsUpdatedAction = (payload) => {
    return {
        type: APP_GROUPS_UPDATED,
        payload: payload,
    };
};

export const appGroupStateUpdated: (payload: ConnectedAppGroupEntityResponse) => AppGroupStateUpdatedAction = (
    payload,
) => {
    return {
        type: APP_GROUP_STATE_UPDATED,
        payload: payload,
    };
};

// Delete app

export const tryDeleteAppGroup: (request: DeleteAppGroupRequest) => TryDeleteAppGroupAction = (request) => {
    return {
        type: TRY_DELETE_APP_GROUP,
        payload: request,
    };
};

export const appGroupsDeleted: (payload: DeletedAppGroupPayload[]) => AppGroupsDeletedAction = (payload) => {
    return {
        type: APP_GROUPS_DELETED,
        payload,
    };
};
